<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>

    <v-row dense
           class="d-flex mx-16">
      <v-col cols="12">
        <v-alert border="left"
                 color="red lighten-2"
                 type="error"
                 text
                 prominent>
          OOPS! This page is unavailable! <br>
          404
          Not Found</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: '404',
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Error',
          disabled: true,
        },
      ],
    }
  },
}
</script>
<style scoped lang="sass">
.breadcrumb
    line-height: 1
    display: inline-block
    margin: 0 0
    vertical-align: middle
    padding: 8px 15px
    margin-top: -5px
    margin-bottom: 10px
    list-style: none
    background-color: #f5f5f5
    border-radius: 4px
</style>